import { Cart } from "./cart-types";

export function quantityByServiceAndVariation({
  cart,
  service,
  variation,
}: {
  cart: Cart;
  service: string;
  variation: string;
}) {
  if (!cart) {
    return 0;
  }
  return cart.items.reduce((prev, nextItem) => {
    if (nextItem.service === service && nextItem.variation === variation) {
      return prev + 1;
    }
    return prev;
  }, 0);
}
